export default __webpack_public_path__ + "static/media/IMG-20220413-WA0016@2x.0ebc78a6.png";